import { defineMessage, defineMessages } from "react-intl";

import SavedAddressType, {
  ReservedSavedAddressType,
} from "@mapmycustomers/shared/enum/SavedAddressType";

import GlobalSearchSectionKey from "../../enum/GlobalSearchSectionKey";

const messages = defineMessages<
  Exclude<GlobalSearchSectionKey, GlobalSearchSectionKey.RECORDS | GlobalSearchSectionKey.SET_MODE>
>({
  [GlobalSearchSectionKey.RECENT]: {
    id: "component.globalSearch.search.recent",
    defaultMessage: "Recent",
    description: "recent text on global search modal",
  },
  [GlobalSearchSectionKey.SAVED_LOCATIONS]: {
    id: "component.globalSearch.resultList.savedLocations",
    defaultMessage: "Saved Locations",
    description: "Heading of the rep's saved locations in universal search",
  },
});

export const setModeCancelMessage = defineMessage({
  id: "component.globalSearch.resultList.setMode.cancel",
  defaultMessage: "Cancel",
  description: "Button that leaves setting the rep's Home or Work in universal search",
});

export const setModeTitles = defineMessages<ReservedSavedAddressType>({
  [SavedAddressType.HOME]: {
    id: "component.globalSearch.resultList.setMode.home.title",
    defaultMessage: "Set your Home",
    description: "Heading in universal search while the rep is choosing their Home",
  },
  [SavedAddressType.WORK]: {
    id: "component.globalSearch.resultList.setMode.work.title",
    defaultMessage: "Set your Work",
    description: "Heading in universal search while the rep is choosing their Work",
  },
});

export const setModeHints = defineMessages<ReservedSavedAddressType>({
  [SavedAddressType.HOME]: {
    id: "component.globalSearch.resultList.setMode.home.hint",
    defaultMessage: "Type an address. Picking one sets your Home straight away.",
    description: "Hint in universal search while the rep is choosing their Home",
  },
  [SavedAddressType.WORK]: {
    id: "component.globalSearch.resultList.setMode.work.hint",
    defaultMessage: "Type an address. Picking one sets your Work straight away.",
    description: "Hint in universal search while the rep is choosing their Work",
  },
});

export default messages;
